<template>
    <div>
        <Table :isEmpty="inPersonHostDefinedMeetingLocations.length === 0">
            <TableHead>
                <TableHeadCell>Address</TableHeadCell>
                <TableHeadCell>Google Maps URL</TableHeadCell>
                <TableHeadCell></TableHeadCell>
            </TableHead>
            <TableBody>
                <TableBodyRow
                    v-for="inPersonHostDefinedMeetingLocation in inPersonHostDefinedMeetingLocations"
                    :key="inPersonHostDefinedMeetingLocation.id"
                >
                    <TableBodyRowCell>
                        {{ inPersonHostDefinedMeetingLocation.address }}
                    </TableBodyRowCell>
                    <TableBodyRowCell>
                        <a
                            v-if="
                                inPersonHostDefinedMeetingLocation.googleMapsUrl
                            "
                            :href="
                                inPersonHostDefinedMeetingLocation.googleMapsUrl
                            "
                            target="_blank"
                            class="hover:underline text-blue-500 flex items-center gap-2"
                        >
                            <span> Open link </span>
                            <Icon
                                name="external-link"
                                class="w-3.5 h-3.5"
                            />
                        </a>
                    </TableBodyRowCell>
                    <TableBodyRowCell class="flex justify-end gap-1">
                        <DeleteInPersonHostDefinedMeetingLocationButtonModal
                            :inPersonHostDefinedMeetingLocation="
                                inPersonHostDefinedMeetingLocation
                            "
                            @onSuccess="
                                handleInPersonHostDefinedMeetingLocationsUpdated(
                                    $event.inPersonHostDefinedMeetingLocations,
                                )
                            "
                        />
                    </TableBodyRowCell>
                </TableBodyRow>
            </TableBody>

            <template #emptyState>
                <TableEmptyState
                    title="No in person meeting locations"
                    subtitle="Click the button below to create the first one."
                >
                    <template #action>
                        <CreateInPersonHostDefinedMeetingLocationButtonDrawer
                            @onSuccess="
                                handleInPersonHostDefinedMeetingLocationsUpdated(
                                    $event.inPersonHostDefinedMeetingLocations,
                                )
                            "
                        />
                    </template>
                </TableEmptyState>
            </template>
        </Table>
        <div
            v-if="inPersonHostDefinedMeetingLocations.length > 0"
            class="flex items-center justify-end mt-4"
        >
            <CreateInPersonHostDefinedMeetingLocationButtonDrawer
                @onSuccess="
                    handleInPersonHostDefinedMeetingLocationsUpdated(
                        $event.inPersonHostDefinedMeetingLocations,
                    )
                "
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'

    import Icon from '@/Shared/Component/Icon.vue'

    import InPersonHostDefinedMeetingLocation from '@/App/Company/Entity/InPersonHostDefinedMeetingLocation'

    import Table from '@/Shared/Component/Table/Table.vue'
    import TableHead from '@/Shared/Component/Table/TableHead.vue'
    import TableHeadCell from '@/Shared/Component/Table/TableHeadCell.vue'
    import TableBody from '@/Shared/Component/Table/TableBody.vue'
    import TableBodyRow from '@/Shared/Component/Table/TableBodyRow.vue'
    import TableBodyRowCell from '@/Shared/Component/Table/TableBodyRowCell.vue'
    import TableEmptyState from '@/Shared/Component/Table/TableEmptyState.vue'

    import CreateInPersonHostDefinedMeetingLocationButtonDrawer from '@/App/Company/Component/InPersonHostDefineMeetingLocation/CreateInPersonHostDefinedMeetingLocationButtonDrawer.vue'
    import DeleteInPersonHostDefinedMeetingLocationButtonModal from '@/App/Company/Component/InPersonHostDefineMeetingLocation/DeleteInPersonHostDefinedMeetingLocationButtonModal.vue'

    const emits = defineEmits<{
        onInPersonHostDefinedMeetingLocationsUpdated: [
            {
                inPersonHostDefinedMeetingLocations: InPersonHostDefinedMeetingLocation[]
            },
        ]
    }>()

    const props = defineProps({
        inPersonHostDefinedMeetingLocations: {
            type: Object as PropType<InPersonHostDefinedMeetingLocation[]>,
            required: true,
        },
    })

    const handleInPersonHostDefinedMeetingLocationsUpdated = (
        inPersonHostDefinedMeetingLocations: InPersonHostDefinedMeetingLocation[],
    ): void => {
        emits('onInPersonHostDefinedMeetingLocationsUpdated', {
            inPersonHostDefinedMeetingLocations:
                inPersonHostDefinedMeetingLocations,
        })
    }
</script>
